import z from "zod";
import RemoteCollection from "../utility/remote-collection";

export const ContactListItemSchema = z.object({});
export const ContactDetailItemSchema = ContactListItemSchema.extend({
  affiliate: z.string().nullish(),
  email: z.string().nullish(),
  name: z.string().nullish(),
  company: z.string().nullish(),
  phone: z.string().nullish(),
  needs: z.string().nullish(),
});

export type ContactListItem = z.output<typeof ContactListItemSchema>;
export type ContactDetailItem = z.output<typeof ContactDetailItemSchema>;
export const contactCollection = new RemoteCollection("/api/contact", ContactListItemSchema, ContactDetailItemSchema);